import { render } from "./PartnerDashboardLocation.vue?vue&type=template&id=2a06fab8&scoped=true"
import script from "./PartnerDashboardLocation.vue?vue&type=script&lang=js"
export * from "./PartnerDashboardLocation.vue?vue&type=script&lang=js"

import "./PartnerDashboardLocation.vue?vue&type=style&index=0&id=2a06fab8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a06fab8"]])

export default __exports__